// // VehicleCard.jsx (rewrite)
// // Goals:
// // - No console.log
// // - Safer date formatting (invalid date -> "—")
// // - Accessible button (aria-label), keyboard focus friendly
// // - Robust fallbacks for missing fields
// // - Keeps your visual structure but cleaner class names + layout hooks

// import './VehicleCard.css';

// const safeText = (v, fallback = '—') => (v === null || v === undefined || v === '' ? fallback : String(v));

// const formatDate = (value) => {
//   if (!value) return '—';
//   const d = new Date(value);
//   if (Number.isNaN(d.getTime())) return '—';
//   return d.toLocaleDateString();
// };

// const VehicleCard = ({ vehicle, onClick }) => {
//   const vehicleId = safeText(vehicle?.vehicleId, 'Unknown');
//   const assignedName = vehicle?.employeeName || vehicle?.assignedEmployeeName || null;
//   const nextService = vehicle?.nextServiceOn || null;

//   const serverText = nextService ? `Service due ${formatDate(nextService)}` : 'No service info';
//   const assignedText = assignedName ? assignedName : 'Unassigned';

//   return (
//     <button
//       type="button"
//       className="vc-card"
//       onClick={onClick}
//       aria-label={`View vehicle ${vehicleId}`}
//     >
//       <span className="vc-glow" aria-hidden="true" />

//       <div className="vc-inner">
//         <div className="vc-head">
//           <div className="vc-icon" aria-hidden="true">
//             <i className="bi bi-truck" />
//           </div>

//           <div className="vc-title">
//             <span className="vc-tag">Vehicle</span>
//             <h3 className="vc-id" title={vehicleId}>
//               {vehicleId}
//             </h3>
//           </div>
//         </div>

//         <div className="vc-meta">
//           <div className="vc-metaItem" title={assignedText}>
//             <i className="bi bi-person" aria-hidden="true" />
//             <span className="vc-ellipsis">{assignedText}</span>
//           </div>

//           <div className="vc-metaItem" title={serviceText}>
//             <i className="bi bi-calendar-event" aria-hidden="true" />
//             <span className="vc-ellipsis">{serviceText}</span>
//           </div>
//         </div>

//         <div className="vc-arrow" aria-hidden="true">
//             <i className="bi bi-arrow-right-short" />
//           </div>
//       </div>
//     </button>
//   );
// };

// export default VehicleCard;

import "./VehicleCard.css";
const VehicleCard = ({
  vehicle,
  onClick,
  selected = false,
  onToggle = () => {},
  showCheckbox = false,
}) => {
  const rego = vehicle?.vehicleCode || "—";
  const driver = vehicle?.employee?.name || "Unassigned";
  const status = vehicle?.subscriptionStatus || "INACTIVE";

  const handleCheckboxClick = (event) => {
    event.stopPropagation();
  };

  const handleCheckboxChange = (event) => {
    event.stopPropagation();
    onToggle(vehicle._id);
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      onClick?.();
    }
  };

  return (
    <div
      className="v-card"
      onClick={onClick}
      onKeyDown={handleKeyDown}
      role="button"
      tabIndex={0}
    >
      <div className="v-card-top">
        <div className="v-card-icon">
          <i className="bi bi-truck" />
        </div>

        <div className="v-card-title">
          <span className="v-card-label">Registration</span>
          <h2 className="v-card-rego">{rego}</h2>
        </div>
      </div>

      <div className="v-card-bottom">
        <div className="v-card-info-pill">
          <i className="bi bi-person" />
          <span>{driver}</span>
        </div>

        {showCheckbox && (
          <div className="v-card-checkbox" onClick={handleCheckboxClick}>
            <input
              type="checkbox"
              checked={selected}
              onChange={handleCheckboxChange}
              aria-label={`Select vehicle ${rego}`}
            />
          </div>
        )}

        <div className={`v-card-info-pill ${status}`}>
          <i className="bi bi-bell" />
          <span>{status}</span>
        </div>

        {/* 
          <div >
            <i className="bi bi-calendar4-event" />
            <span>Due {new Date(dateService).toLocaleDateString('en-AU', { day: 'numeric', month: 'short' })}</span>
          </div>
         */}
      </div>

      <div className="v-card-chevron">
        <i className="bi bi-chevron-right" />
      </div>
    </div>
  );
};

export default VehicleCard;
